import posed from 'react-pose';


let AnimatedDivSlide = posed.div({
    visible: {
        width: window.innerWidth <= 576 ? '100vw' :
            window.innerWidth <= 768 ? '100vw' :
                window.innerWidth <= 992 ? '75vw' :
                    window.innerWidth <= 1200 ? '50vw' : '35vw',
        opacity: 1,
        transition: {
            ease:[0.530, 0.035, 0.070, 1.290],
            duration: 500,
        }
    },
    hidden: {
        width:'0',
        opacity: 1,
        transition: {
            ease:[0.530, 0.035, 0.070, 1.290],
            duration: 500,
        }
    }
});

export default AnimatedDivSlide;



// WEBPACK FOOTER //
// ./src/animations/src/AnimatedDivSlide.js